import React from 'react';
import TopBar from '../components/TopBar';
import PowerBIEmbed from '../components/PowerBIEmbed';

const UCCInventories = ({ userClaims }) => {
  return (
    <div className="min-h-screen bg-gray-100">
      <TopBar currentPage="ucc-inventories" userClaims={userClaims} />
      <div className="p-4">
        <div className="bg-white shadow-md rounded-lg p-6">
          <div className="mb-6">
            <h1 className="text-2xl font-bold text-gray-800 mb-2">UCC Inventories</h1>
          </div>
          
          <div className="w-full" style={{ height: 'calc(100vh - 200px)' }}>
            <PowerBIEmbed
              reportId="e3502771-320b-4129-99c8-b935104d6783"
              workspaceId="7d441575-4aa9-4260-99dd-543f002c0340"
              height={800}
          
            />
          </div>
        </div>
      </div>
      
      </div>
  );
};

export default UCCInventories; 
